/*
    用来根据老的state 和指定的action 生成并返回新的state 的函数
*/
import {combineReducers} from 'redux'


function xxx (state=0,action) {
    return state
}
function yyy (state=0,action){
    return state
}

export default combineReducers({
    xxx,
    yyy
})
